import React, { FC, useEffect, useState } from 'react';
import Select from '@domain-group/fe-co-select';
import { useStatus } from '../status-store';
import * as PortalApi from '../../lib/portal-api';

interface SecretListProps {
  credentialId: string;
  onChange: (selectedSecret: PortalApi.SecretViewModel) => void;
}

interface SelectOption {
  label: string;
  value: string;
  data: PortalApi.SecretViewModel;
}

const SecretList: FC<SecretListProps> = ({ credentialId, onChange }) => {
  const [options, updateOptionList] = useState<SelectOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const status = useStatus();
  useEffect(() => {
    const fetchOptionList = async () => {
      setIsLoading(true);
      const credential = await PortalApi.getCredential(
        status.accessToken,
        credentialId,
      );
      const secrets = credential?.secrets ?? [];
      updateOptionList(
        secrets.map((secret) => ({
          label: `${secret.description}`,
          value: secret.id,
          data: secret,
        })),
      );
      setIsLoading(false);
    };
    fetchOptionList();
  }, [credentialId, status.accessToken]);

  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <Select
      instanceId="swagger-secret-chooser"
      stretched
      label="Choose Secret"
      labelHidden={false}
      placeholder="Choose Secret"
      options={options}
      nowrap
      onChange={(selectedItem: SelectOption) => onChange(selectedItem.data)}
    />
  );
};

export default SecretList;
